import { CurrencyAmount } from '~/components/component-library/CurrencyAmount'
import { cn } from '~/utils/tailwind-utils'

import type { PricePoint } from '~/hooks/useTokenPriceChart'

const formatChange = (change: number) => {
  const sign = change > 0 ? '+' : ''
  return `${sign}${(change * 100).toFixed(2)}%`
}

export const PriceChartHeader = ({ prices }: { prices: PricePoint[] }) => {
  const first = prices.at(0)?.p
  const last = prices.at(-1)?.p

  if (first === undefined || last === undefined) return null

  const change = first === 0 ? 0 : (last - first) / first

  return (
    <div className="flex items-baseline gap-2">
      <span className="text-2xl font-semibold">
        <CurrencyAmount layout="inline" value={last} />
      </span>
      <span
        className={cn('text-sm font-medium tabular-nums', {
          'text-green-600': change > 0,
          'text-red-600': change < 0,
          'text-secondary': change === 0,
        })}
      >
        {formatChange(change)}
      </span>
    </div>
  )
}
